import Vue from 'vue';
import { Modal } from 'iview';
import store from '@/store'

export default {
  install (Vue, options = {}) {
    Vue.prototype.$dialog = modal
  }
};

const modal = (config) => {
  const div = document.createElement('div');
  const el = document.createElement('div');
  div.appendChild(el);
  document.body.appendChild(div);
  let currentConfig = { ...config, close, value: true };

  let dialogInstance = null;
  const dialogProps = { props: {} };
  function close(...args) {
    const triggerOk = args.some(param => param && param.triggerOk);
    const triggerCancel = args.some(param => param && param.triggerCancel);
    console.log(triggerCancel , config.onCancel)
    if (triggerCancel) {
      if(config.onCancel){
        let ret = config.onCancel(...args)
        
        if(ret && ret.then){
          ret.then((...args) => {
            destroy(...args)
          },()=>{

          })
        }
        else{
          if(ret !== false)
            destroy(...args)
        }
      }else{
        destroy(...args)
      }
      
    }

    if (triggerOk) {
      if(config.onOk){
        let ret = config.onOk(...args)
        
        if(ret && ret.then){
          
          //Vue.set(dialogInstance,'dialogProps.confirmLoading',true)
          
          ret.then((...args) => {
            destroy(...args)
          },()=>{

          })
        }
        else{
          if(ret !== false)
            destroy(...args)
        }
      }else{
        destroy(...args)
      }
      
    }
  }

  function update(newConfig) {
    currentConfig = {
      ...currentConfig,
      ...newConfig,
    };
    dialogProps.props = currentConfig;
  }
  function destroy(...args) {
    console.log('destroy',dialogInstance,div.parentNode)
    if (dialogInstance && div.parentNode) {
      dialogInstance.$destroy();
      dialogInstance = null;
      div.parentNode.removeChild(div);
    }

  }

  function preRender(h , tag , args , nodes) {
    if(Object.prototype.toString.call(args) != '[object Object]'){
      nodes = args
      args = {}
    }

    if(!args.on) args.on = {}
    args.on.close = (data) => {
      close({ triggerCancel: true , data})
    }
    args.on.ok = (data) => {
      close({ triggerOk: true , data})
    }
    return h(tag , args, nodes)
  }

  function render(props) {
    dialogProps.props = props;
    return new Vue({
      el, store,
      data() {
        return { dialogProps };
      },
      render() {
        // 先解构，避免报错，原因不详
        const cdProps = { ...this.dialogProps };
        if( cdProps.props.paddingless ){
          delete cdProps.props.paddingless
          cdProps.props.className = cdProps.props.className + ' paddingless'
        }
        if( cdProps.props.maskClosable !== true){
          cdProps.props.maskClosable = false
        }

        const slots = {}

        if(cdProps.props.render){
          slots.default = cdProps.props.render((...rest) => preRender(h,...rest))
        }else if(cdProps.props.component){

          const args = {
            on:{
              cancel(data){
                close({ triggerCancel: true , data})
              },
              ok(data){
                close({ triggerOk: true , data})
              }
            },
            props:cdProps.props.props || {}
          }

          slots.default = h(cdProps.props.component , args)
          
        }

        return <Modal 
          {...cdProps}
          on-on-cancel={e => close({ triggerCancel: true }, e)} 
          on-on-ok={e => close({ triggerOk: true }, e)}
        >{slots.default}</Modal>;
      },
    });
  }

  dialogInstance = render(currentConfig);

  return {
    destroy: close,
    update,
  };
}

modal.show = modal